import { useEffect, useState } from "react";
import { MAGNOLIA_FETCH_ERROR } from "@/utilities/constants/dynatrace";
import { getContent } from "@/utilities/functions/magnoliaUtils";
import { reportDtCustomError } from "br2s-ui-common-utils-02";
import { NoticeBanner } from "br2s-ui-componentlibrary_r2_02";
import Richtext from "@/components/Richtext/Richtext";
import './NoticeBannerModule.scss';

interface NoticeBannerProps {
  /**
   * Component id
   */
  id: string;
  /**
   * State to display notice banner
   */
  isHidden: boolean;
  /**
   * Headline text that will be shown in bold weight
   */
  headline?: string;
  /**
   * Content of the notice banner
   */
  content: string;
  /**
   * Callback to call on notice banner dismiss
   */
  onDismiss: () => void;
  /**
   * Does notice banner have auto dismiss
   */
  isAutoDismiss?: boolean;
  /**
   * Dismiss duration (in ms). Default duration is 3000ms
   */
  autoDismissDuration?: number;
}

interface NoticeBannerModuleProps {
  contentPath: string;
}

function NoticeBannerModule(props: Readonly<NoticeBannerModuleProps>) {
  const initState: NoticeBannerProps = {
    id: 'notice-banner',
    isHidden: true,
    onDismiss: () => {},
    content: ''
  };
  const [contentRsp, setContentRsp] = useState(initState);
  const [contentIsLoaded, setContentIsLoaded] = useState(false);

  useEffect(() => {
    async function loadContent() {
      const nodeName = process.env.REACT_APP_MGNL_APP_BASE;
      const contentPath = nodeName + props.contentPath;

      try {
        const content = await getContent(contentPath);
        setContentRsp(content);
        setContentIsLoaded(true);
      } catch(error) {
        console.error(error);
        reportDtCustomError(
          MAGNOLIA_FETCH_ERROR,
          'Could not fetch Magnolia notice-banner content.',
          `Content path: ${contentPath} | Error: ${JSON.stringify(error)}`,
        );
      }
    }

    loadContent();
  }, []);

  return (
    <>
      {contentIsLoaded && (
        <NoticeBanner
          id={contentRsp.id}
          headline={contentRsp.headline}
          isHidden={contentRsp.isHidden}
          onDismiss={() => {}}
          isAutoDismiss={contentRsp.isAutoDismiss}
          autoDismissDuration={contentRsp.autoDismissDuration}>
            <Richtext content={contentRsp.content} />
        </NoticeBanner>
      )}

    </>
  );
}

export default NoticeBannerModule;
